import axios from "axios";
import { useState } from "react";

export default function Uploadfile() {
    const [selectedFile, setSelectedFile] = useState('');

    const onFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    }
    const onFileUpload = () => {
        const formData = new FormData();
        formData.append('contexnac', selectedFile);

        axios.post('http://127.0.0.1:8001/api/uploadtb',formData, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        }).then(function(response) {})
        .catch(function(error) {});
    }
    return <>
        <div>
            <input type="file" onChange={onFileChange}></input>
            <button onClick={onFileUpload}>CARGAR ARCHIVO</button>
        </div>
    </>
}